export default function() {
  return {
    dataSources: {},
    dataSourcesById: [],
  };
}
